import { type NotivueTheme, pastelTheme } from 'notivue'

export const notivueTheme: NotivueTheme = {
  ...pastelTheme,
  '--nv-spacing': '1rem',
}
